import React, {ReactNode, useState} from 'react';

export type WdiPanelProps = {
  defaultCollapsed?: boolean;
  collapsed?: boolean;
  title?: ReactNode;
  extra?: ReactNode;
  filter?: ReactNode;
  description?: ReactNode;
  onClick?: () => void;
};

enum style {
  collapsed = "none",
  expanded = "block",
};

const WdiPanel: React.FC<WdiPanelProps> = (props) => {
  const [isCollapsed, setIsCollapsed] = React.useState<boolean>(props.defaultCollapsed ? props.defaultCollapsed : false);
  // 初始化一个状态来跟踪点击是否已经发生
  const [isClicked, setIsClicked] = useState(false);
  // 点击事件处理函数
  const handleClick = () => {
    if (!isClicked) {
      // 只有在未点击时才执行这里的代码
      props.onClick ? props.onClick() : null;
      // 更新状态，标记为已点击
      setIsClicked(true);
    }
  };
  return (
    //onClick只会触发一次
    <div className='wdi-panel' onClick={handleClick}>
      <div
        className="ant-pro-card-header ant-pro-card-header-border ant-pro-card-header-collapsible"
        style={{height: '40px', padding: '0px'}}
        onClick={() => {
          props.collapsed ? setIsCollapsed(!isCollapsed) : null;
        }}>
        <div className="ant-pro-card-title" style={{width: '100%', fontSize: '15px'}}>
          <span>{props.title}</span>
          {props.description && (
            <span style={{paddingLeft: '10px', fontSize: '14px', fontWeight: 'normal'}}>
              {props.description}
            </span>
          )}
          <span
            style={{marginLeft: '100px', fontSize: '14px', fontWeight: 'normal'}}
            onClick={event => event.stopPropagation()}
          >
            {props.filter}
          </span>
          <div className='ant-btn-group ant-dropdown-button' style={{float: 'right'}}
               onClick={event => event.stopPropagation()}>
            {props.extra}
          </div>
        </div>
      </div>
      <div className="ant-pro-card-col">
        <div className="ant-pro-card ant-pro-card-contain-card ant-pro-card-ghost">
          <div className="ant-pro-card-body">
            <div
              className="collapse-content"
              style={{width: '100%', display: (isCollapsed ? style.collapsed : style.expanded)}}
              aria-expanded={isCollapsed}
            >
              <div style={{marginTop: '10px'}}>
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {WdiPanel}
